//***** Hooks *****
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
// ***** Components *****
import SubHeaderDevices from '@modules/devices/components/devices-list/list-devices/SubheaderDevices';
import EmptyDevices from '@modules/devices/components/devices-list/list-devices/EmptyDevices';
import ListDevices from '@modules/devices/components/devices-list/list-devices/ListDevices';
import Table from '@components/table/table';
import { deleteDevices } from '@modules/devices/utils/devices';
import ItemList from '@modules/devices/components/devices-list/list-devices/ItemList';
import Loader from '@components/loader/loader';
// ***** Interfaces, Types and imports *****
import { newDeviceProps } from '@modules/devices/types/types-devices';
import Host from '@interfaces/device/host';
import InfoTableContentI, { InfoTableButtonsI } from '@interfaces/tables/tables';
import DeleteModal from '@modules/practitioner/profile/public/Education/DeleteModal';
import DetailedTable from '@components/detailed-table/detailed-table';
import { notify } from '@functions/notification';

type DevicesListProps = {
  devices: Array<newDeviceProps>
  onToggle: () => void,
  setDeviceEdit: (device?: newDeviceProps) => void,
  addNewDevice: () => void,
  ready: boolean,
  hostToDevice?: Host
  updateDevices?: () => void,
}

const DevicesListScreen = (props: DevicesListProps) => {
  const {devices, onToggle, setDeviceEdit, addNewDevice, ready, hostToDevice } = props
  const { t } = useTranslation(['myDevices']);
  const [devicesFiltered, setDevicesFiltered] = useState<Array<newDeviceProps>>([]);
  const [deviceShowSelected, setdDeviceShowSelected] = useState<newDeviceProps | undefined>();
  const [openModal, setOpenModal] = useState(false);

  const deleteDevice = async (id?: number) => {
    if (!id) return;
    const devices = devicesFiltered.filter(device => device.deviceId !== id);
    setDevicesFiltered(devices);
    try {
      const resp = await deleteDevices(id);
      if(resp){
        notify({ message: t('notify.deleteDeviceSuccess'), messageType: 'success' });
        setOpenModal(false)
        setdDeviceShowSelected(undefined)
        updateDevices()
      }
    } catch (error) {
      notify({ message: t('notify.deleteDeviceError'), messageType: 'error' });
      console.debug(error)
    }
  }
  const updateDevices = () =>{
    if(props.updateDevices){
      props.updateDevices()
    }
  }

  /**
   * Set the deviceShowSelected and change the view to DetailedTable component
  */
  const changedeviceShowSelected = (device: newDeviceProps) => {
    setdDeviceShowSelected(device)
  }

  /**
   * Set the deviceShowSelected to undefined and change the view to Table view
  */
  const cleandeviceShowSelected = () => {
    setdDeviceShowSelected(undefined)
  }

  /**
   * Function to get the values to render in DetailedTable component
  */
  const getContent = () => {
    if (!deviceShowSelected) return;
    const content: InfoTableContentI[] = [
      {
        label: t('table.id'),
        value: deviceShowSelected.identification
      },
      {
        label: t('table.devices'),
        value: deviceShowSelected.deviceType.code
      },
      {
        label: t('table.room'),
        value: ` ${deviceShowSelected.nestedOrganizationStructure.organizationName}`
      },
      {
        label: t('table.serialN'),
        value: ` ${deviceShowSelected.serialNumber}`
      },
    ]
    return content
  };

  /**
   * Function to get the buttons to render in DetailedTable component
  */
  const getButtons = () => {
    if (!deviceShowSelected) return undefined;
    const buttons: InfoTableButtonsI[] = [
      {
        buttontext: t('buttons.deleteDevice'),
        action: () => setOpenModal(true),
        outlined: true
      },
      {
        buttontext: t('buttons.editDevice'),
        action: () => setDeviceEdit(deviceShowSelected),
        outlined: false
      },
    ]
    return buttons
  };

  useEffect(() => {
    setDevicesFiltered(devices);
  }, [devices])

  return (
    <div className="AddDevice">
      <DeleteModal
        openModal={openModal}
        setOpenModal={setOpenModal}
        onDeleteRow={() => deleteDevice(deviceShowSelected?.deviceId)}
      />
      {deviceShowSelected ?
        <DetailedTable
          title={`ID ${deviceShowSelected.deviceId}`}
          goBack={() => cleandeviceShowSelected()}
          content={getContent()}
          buttons={getButtons()}
        />
      : 
      <>
        <SubHeaderDevices
          onToggle={() => onToggle()}
          addNew={addNewDevice}
          hostToDevice={hostToDevice}
        />
        {!ready && <Loader />}
        {
          !devices.length
            ? (<EmptyDevices />)
            : (<ListDevices devices={devices} />)
        }

        {ready &&
          <Table type={1}>
            <>
              {/*<TableHeaders type={1}>*/}
              {/*  <>*/}
              {/*    <TableHead type={1} text={"Nombre del usuario"} />*/}
              {/*    <TableHead type={1} text={"Correo electronico"} />*/}
              {/*    <TableHead type={4} text={"Rol"} />*/}
              {/*    <TableHead type={4} text={"Estatus"} />*/}
              {/*  </>*/}
              {/*</TableHeaders>*/}
              {/*{practitioners.map((practitioner: PractitonerListI) =>*/}
              {/*  <PractitionerItem user={practitioner} />*/}
              {/*)}*/}
              {
                devicesFiltered.map(dev => (
                  <ItemList
                    key={dev.deviceId}
                    dev={dev}
                    deleteDevice={() => deleteDevice(dev.deviceId)}
                    setDeviceEdit={setDeviceEdit}
                    setdDeviceShowSelected={(device) => changedeviceShowSelected(device)}
                  />
                ))
              }

            </>
          </Table>
        }
      </>
      }
    </div>
  );
};

export default DevicesListScreen;
